// extracted by mini-css-extract-plugin
module.exports = {"nav":"MenuMobile_nav__5C9gO","nav-item-wrapper":"MenuMobile_nav-item-wrapper__z_cvr"};